import { Component, ElementRef, HostListener, EventEmitter, Input, Output,
   OnInit, ChangeDetectionStrategy, DoCheck, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { User, Class} from '../../../../../projectmanagement/src/app/model/project.model';

import * as projectforms from '../../../../../projectmanagement/src/app/forms/projectmanagement.form';
import { UserManagementService } from '../../../../../tools/src/service/user.management.service';
import { SchoolManagementService } from '../../../../../schoolmanagement/src/app/service/schoolmanagement.service';

import { MyErrorHandler } from '../../errorhandler/errorhandler';
import { Datepicker } from '@eds/vanilla';

import { environment } from '../../../../../../src/environments/environment';

declare var jQuery: any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-new-user-form',
  templateUrl: './CtlNewUserForm.html',
  styleUrls: ['./CtlNewUserForm.css'],
  providers: [UserManagementService, SchoolManagementService]
})

export class CtlNewUserForm implements OnInit, AfterViewInit {
  @ViewChild('usrstatus') usrstatus: ElementRef;
  @ViewChild('dp') dp: ElementRef;
  @Input() project_id: string;
  @Input() school_id: string;
  @Input() formFor: string;
  @Input() viewType: string;
  @Input() projPartnerList: any[];
  @Input() data: any;
  @Input() projectData: any;
  @Input() schoolData: any;
  @Input() keySubjectListDropdownForTeacher: any[];
  @Input() user_id: string;
  @Input() newPassword: string;
  loginGenerated = false;

  loaded = false;

  @Input() myFormGroup: FormGroup;
  @Input() myrole: string;
  @Input() status: boolean;
  @Input() logo: {};
  @Input() first_name: string;
  @Input() last_name: string;
  @Input() email: string;
  myRoleName: string;

  @Output() userFormChange: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshUserList: EventEmitter<boolean> = new EventEmitter();
  @Output() activeArchiveAdmin: EventEmitter<boolean> = new EventEmitter();
  @Output() activeArchiveUser: EventEmitter<boolean> = new EventEmitter();
  @Output() evEditEnable: EventEmitter<boolean> = new EventEmitter();

  @Output() changeButtonInViewAdmin: EventEmitter<boolean> = new EventEmitter();
  // complete form user
  userForm: FormGroup;
  partnerList: any[];

  logo_url: string;
  user: User;

  @Input() isTeacher = false;
  @Input() isProjectAdmin = false;
  @Input() isSchoolAdmin

  roleListData: any[];
  @Input() partnerListData: any[];
  gradeListData: any[] = [];
  classListData: Class[];
  statusVal: string;
  action: string;
  message: string;
  adminActiveArchiveTab: boolean;
  subjectsListData;
  projSubjectsListData;

  tpartner;
  trole;
  oldData;
  selectConfig = {
    displayKey: 'name',
    search: false,
    limitTo: 5
  };
  roleSelectConfig:any;
  partnerSelectConfig:any;
  genderSelectConfig:any;
  gradeSelectConfig:any;
  classSelectConfig:any;
  subjectSelectConfig:any;
  
  
  @Input() dpFlag: boolean;
  dateOfBirth = '';

  genderList = [
    'Male','Female','Other'
  ];

  environment;
  loggedUserData: any;
  loggedUserIsLead: any; //{"lead":{"type":''}};
  isLead: boolean;
  textDir:any;
  constructor(
    private _fb: FormBuilder,
    private el: ElementRef,
    public translate: TranslateService,
    private userService: UserManagementService,
    private schoolService: SchoolManagementService,
    private router: Router,
    private route: ActivatedRoute) { 
      this.textDir =  sessionStorage.getItem('textDir');
    }

  ngOnInit() {
    //
    // this.userForm.reset();
    this.environment = environment;
    this.loggedUserData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    this.loggedUserIsLead = JSON.stringify(this.loggedUserData.role.lead);

    if (this.loggedUserIsLead === undefined || this.loggedUserIsLead === 'null'){
      this.isLead = false;
    } else {
      this.isLead = true;
    }
    this.translate.get('Select role').subscribe((translated: string) => {
      this.roleSelectConfig = {
        placeholder: translated,
        displayKey: 'desc',
        search: false,
        limitTo: 5
      };
      this.partnerSelectConfig = {
        placeholder: this.translate.instant('Select an organization'),
        displayKey: 'name',
        search: false,
        limitTo: 5
      };
      this.genderSelectConfig = {
        placeholder: this.translate.instant('Select gender'),
        search: false,
        limitTo: 3
      };
      this.gradeSelectConfig = {
        placeholder: this.translate.instant('Select grade'),
        displayKey: 'name',
        search: false,
        limitTo: 5
      };
      this.classSelectConfig = {
        placeholder: this.translate.instant('Select class'),
        displayKey: 'name',
        search: false,
        limitTo: 5
      };
      this.subjectSelectConfig = {
        placeholder: this.translate.instant('Select key subject'),
        displayKey: 'name',
        search: false,
        limitTo: 5
      };
    });


    if (this.school_id) {
      this.getGradeClassList();
      this.getProjectSubjectsList();
    }

    this.getRoleList();

    if (this.myrole) {
      this.myRoleName = this.getRole(this.myrole);
    }

    if (this.data && this.data.name) {
      this.myFormGroup.patchValue(this.data);
      this.oldData = {...this.data};
      this.tpartner = {...this.data.partner};
      this.trole = {...this.data.role};
    }
  }

  ngDoCheck() {
    if (this.data && this.data !== this.oldData) {
      this.oldData = {...this.data};
    }
    if (this.dp) {
      if (this.dpFlag){
        this.datePickerInit();
        this.dpFlag = false;
      }
    }
  }

  ngAfterViewInit() {
    //setTimeout(() => { this.datePickerInit(); }, 1000);
    this.datePickerInit();
  }

  datePickerInit(){
    const datepickers = document.querySelectorAll('.datepicker');
    if (datepickers) {
      Array.from(datepickers).forEach((datepicker1) => {
        const datepicker = new Datepicker(datepicker1 as HTMLElement);
        datepicker.init();
      });
    }
  }

  datepickerChange(event){
    this.myFormGroup.controls.date_of_birth.patchValue(event.target.value);
    this.formChanged(event);
  }

  /* This method is call to refresh the active/archive toggle button. It will be removed if found better solutions. */
  ngOnChanges(){
   // console.log(JSON.stringify(this.data));
    if (typeof this.data !== 'undefined' && (this.viewType === 'read' || this.viewType === 'edit')){
      if (typeof this.data.active !== 'undefined'){
        const usrStat = this.data.active;
        if (this.usrstatus){
          console.log(this.usrstatus);
          console.log(usrStat);
          this.usrstatus.nativeElement.checked = usrStat;
        }
      }
    }
  }

  nameChanged(event) {
    console.log('changed :' + event.target.value);
    this.userFormChange.emit(true);
    if (!this.myFormGroup.get('username').value && (
      this.myFormGroup.get('first_name').value &&
      this.myFormGroup.get('last_name').value)) {
        //
        this.generateUserPass();
    }
  }

  getGradeClassList() {
    this.schoolService.getClassList(this.school_id).subscribe(
      (response) => {
        this.classListData = [];
        const classList = response;
        try {
          for (const myclass of classList) {
            if ( myclass.grade &&
              this.gradeListData &&
              this.gradeListData.map((e) => e.name).indexOf(myclass.grade.name) === -1) {
              this.gradeListData.push(myclass.grade);
            }
          }

          let i = 0;
          for (const grade of this.gradeListData) {
            this.gradeListData[i].classes = [];
            classList.forEach(item => {
              if (item.grade && grade._id === item.grade._id) {
                if ( this.gradeListData[i].classes.map( (e) => e.name).indexOf(item.name) === -1 ) {
                  this.gradeListData[i].classes.push({_id: item._id, name: item.name});
                }
              }
            });
            i++;
          }
        } catch (err) {
          this.loaded = true;
          return true;
        }
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
     // console.log('COMPLETED');
      }
    );
  }

  populateClass(key, val) {
    if (typeof(this.myFormGroup.get('grade').value) !== 'undefined'){
      val = this.myFormGroup.get('grade').value._id;
      if (key === 'grade') {
        this.classListData = [];
        if (this.gradeListData) {
          this.gradeListData.forEach(element => {
            if (element._id === val) {
              this.classListData = element.classes.slice(0);
              this.classListData = [...this.classListData];
              this.myFormGroup.get('class').patchValue(null);
              this.myFormGroup.get('class').setErrors({incorrect: true});
            }
          });
        }
      }
      this.formChanged('');
    }
   // console.log("this.classListData="+JSON.stringify( this.classListData));
  }
  refreshClass(evt){
    if (typeof(this.myFormGroup.get('grade').value) !== 'undefined'){
      const val = this.myFormGroup.get('grade').value._id;
      this.classListData = [];
      if (this.gradeListData) {
        this.gradeListData.forEach(element => {
          if (element._id === val) {
            this.classListData = element.classes.slice(0);
            this.classListData = [...this.classListData];
          }
        });
      }
    }
    this.formChanged(evt);
  }
  btnStatus(){
    if (this.myFormGroup.get('grade').value._id !== undefined &&
      this.myFormGroup.get('class').value._id !== undefined){
        this.userFormChange.emit(true);
      }
  }

  /*getSubjectsList() {
    this.schoolService.getSubjectList(this.project_id).subscribe(
      (response) => {
        this.subjectsListData = response;
        console.log("1 this.subjectsListData="+JSON.stringify(this.subjectsListData));
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandler = new ErrorHandler(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }*/

  getProjectSubjectsList() {
    this.schoolService.getProjectSubjectList(this.project_id).subscribe(
      (response) => {
        this.projSubjectsListData = response[0];
        if (this.projSubjectsListData.subjects){
          this.subjectsListData = [...this.projSubjectsListData.subjects];
        }
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }

  myListFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.desc;
  }
  myListFormatterForRole(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.desc;
  }
  myValueFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.desc;
  }

  roleChanged(data: any) {
    if (data && data.name) {
      this.myrole = data.name;
      this.myRoleName = data.desc;
    }
  }

  generateUserPass() {
    let domain = '';
    if (this.projectData && this.projectData.code) {
      domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      domain = this.schoolData.code;
    }

    const data = {
      first_name: this.myFormGroup.get('first_name').value,
      last_name: this.myFormGroup.get('last_name').value,
      domain: domain
    };

    let admin_name = data.first_name.charAt(0).toUpperCase() +
    data.first_name.slice(1) + ' ' +  data.last_name.charAt(0).toUpperCase() + data.last_name.slice(1);
    window.localStorage.setItem('admin_name', admin_name);

    if (data.first_name && data.last_name && data.domain) {

      this.userService.generateLogin(JSON.stringify(data)).subscribe(
        (response) => {
          this.myFormGroup.get('username').patchValue(response.username);
          this.myFormGroup.get('password').patchValue(response.password);
          this.loginGenerated = true;
          //this.addUser();
        },
        (err) => {
          console.log('ERROR: ' + err );
        },
        () => {
         // console.log( 'COMPLETED' );
        }
      );
    }
  }

  edit() {
   this.evEditEnable.emit(true);
  }
  getRoleList(): any {
    const listroles = [];
    this.userService.listRoles().subscribe(
      (response) => {
       console.log(' Full Response Role: ' + JSON.stringify(response));

        if (this.myrole === 'ProjectAdmin') {
          response.forEach(element => {
            if (element.name === 'ProjectAdmin' || element.name === 'ContentProvider') {
              listroles.push(element);
            }
          });
          this.roleListData = listroles;
        } else {
          this.roleListData = response.slice();
        }
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err );
      },
      () => {
        //console.log( 'COMPLETED' );
      }
    );
  }

  getRoleID(name: string) {
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i]._id;
        }
      }
    }
    return;
  }

  getRoleFromID(role_id: string) {

    console.log('role id :' + role_id);
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i]._id === role_id) {
          return this.roleListData[i].name;
        }
      }
    }
    return;
  }



  getRole(name: string) {

    //console.log('role name :' + name);
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i].desc;
        }
      }
    }
    return;
  }

  setDate(event) {
    if (event.target.value) {
      this.myFormGroup.controls['date_of_birth'].patchValue(event.target.value);
    }
  }
  setDob(e){
    console.log(e);
  }
  addUser() {
    // console.log('User Form Data for add' + JSON.stringify(this.myFormGroup.value));

    // redirect on success
    const data = this.myFormGroup.value;
    if (data.role) {
      data['role_id'] = data.role._id;
      delete data.role;
    }
    if (data.partner) {
      data['partner_id'] = data.partner._id;
      delete data.partner;
    }

    if (data.key_subject) {
      data['key_subject_id'] = data.key_subject._id;
      delete data.key_subject;
    }
    if (this.project_id) {
      data.project_id = this.project_id;
    }
    if (this.school_id) {
      data.school_id = this.school_id;
    }

    if ( data._id) {
      delete data._id;
    }

    if (this.projectData && this.projectData.code) {
      data.domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      data.domain = this.schoolData.code;
    }

    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
    for (const key of Object.keys(data)) {
      if (key === 'partner') {
          data['partner_id'] = data[key];
          delete data.partner;
      }
      if (key === 'role') {
        if (data[key] && data[key]['_id']) {
        data['role_id'] = data[key]['_id'];
        delete data.role;
        }
      }
      if (key === 'grade') {
        if (data[key]) {
        //data['grade_id'] = data[key];
        delete data.grade;
        }
      }
      if (key === 'class') {
        if (data[key]) {
        data['class_id'] = data[key]['_id'];
        delete data.class;
        }
      }

      if (key === 'active') {
        delete data.active;
      }
    }

    if (!data.role_id && this.myrole) {
      data.role_id = this.getRoleID(this.myrole);
    }

    if (data.gender) {
      data.gender = data.gender.charAt(0).toLowerCase() + data.gender.slice(1);
    }

    let admin_name = data.first_name.charAt(0).toUpperCase() +
    data.first_name.slice(1) + ' ' +  data.last_name.charAt(0).toUpperCase() + data.last_name.slice(1);
    window.localStorage.setItem('admin_name', admin_name);
    this.userService.create(JSON.stringify(data)).subscribe(
      (response) => {
      //  console.log(' Full Response: ' + JSON.stringify(response));
        this.action = 'success';
        this.message = this.translate.instant('User added successfully!');
        this.refreshUserList.emit(true);
         // this.userFormChange.emit(true);
      },
      (err) => {
        this.action = 'failure';
        this.message = this.translate.instant('Failed to add user, try again or contact administrator!');
        // this.userFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
      //  console.log('COMPLETED');
      }

    );
  }
  userAccessAllowed(){
    const data = this.myFormGroup.value;
    data.domain = this.schoolData.code;
    data.request_status = this.viewType;
    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
    for (const key of Object.keys(data)) {
      if (key === 'grade') {
        if (data[key]) {
         var temp = data[key]['name'];
          delete data.grade;
          data['grade'] = temp;
        }
      }
      if (key === 'class') {
        if (data[key]) {
          data['class_id'] = data[key]['_id'];
          var temp = data[key]['name'];
          delete data.class;
          data['class'] = temp;
        }
      }
      if (key === 'contact') {
        delete data.contact;
      }

      if (key === 'role') {
        delete data.role;
        }
      if (key === 'gender') {
        delete data.gender;
      }
      if (key === 'active') {
         delete data.active;
       }
       if (key === 'address') {
        delete data.address;
      }
      }

    console.log('Allow post data=' + JSON.stringify(this.user_id));
    this.userService.allowAccess(this.user_id, JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Allowed Full Response: ' + JSON.stringify(response));
       this.action = 'success';
     //  this.message = 'This student is now assigned to their Class and their account is ActivatedRoute.';
       this.refreshUserList.emit(true);
      },
      (err) => {
        this.action = 'failure';
        this.message = this.translate.instant('Failed to allow user, try again or contact administrator!');
        // this.userFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
        console.log('COMPLETED');
      }

    );

  }

  updateUser() {
    // let userdob =  jQuery('#dob').val();
    // if (userdob) {
    //   const str = userdob.split('-');
    //   let temp = '';
    //   temp = str[0];
    //   str[0] = str[2];
    //   str[2] = temp;
    //   userdob = str[0] + '-' + str[1] + '-' + str[2];
    // }
    // alert(userdob);
    // this.myFormGroup.controls['date_of_birth'].patchValue(userdob);

    const data = this.myFormGroup.value;
    //console.log(data);
    if (data.role) {
      data['role_id'] = data.role._id;
      delete data.role;
    }
    if (data.partner) {
      data['partner_id'] = data.partner._id;
      delete data.partner;
    }
    if (data.key_subject) {
      data['key_subject_id'] = data.key_subject._id;
      delete data.key_subject;
    }
    if (this.project_id) {
      data.project_id = this.project_id;
    }
    if (this.school_id) {
      data.school_id = this.school_id;
    }

    if ( data._id) {
      delete data._id;
    }
   // alert("1");
    if (this.projectData && this.projectData.code) {
      data.domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      data.domain = this.schoolData.code;
    }
   // alert("2");
    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
    for (const key of Object.keys(data)) {
      if (key === 'partner') {
        data['partner_id'] = data[key];
        delete data.partner;
    }
      if (key === 'role') {

        if (data[key] || data[key]['id']) {
          data['role_id'] = data[key]['_id'];
          delete data.role;
        }
      }
      if (key === 'grade') {
        if (data[key]) {
        // data['grade_id'] = data[key];
        delete data.grade;
        }
      }
      if (key === 'class') {
        if (data[key]) {
          data['class_id'] = data[key]['_id'];
          delete data.class;
        }
      }
      if (key === 'active') {
        delete data.active;
      }
    }

    if (!data.role_id && this.myrole) {
      data.role_id = this.getRoleID(this.myrole);
    }
    if (data.gender) {
      data.gender = data.gender.charAt(0).toLowerCase() + data.gender.slice(1);
    }

    this.userService.update(this.user_id, JSON.stringify(data)).subscribe(
      (response) => {
       this.action = 'success';
       this.message = this.translate.instant('User updated successfully!');
       this.refreshUserList.emit(true);
      },
      (err) => {
        this.action = 'failure';
        this.message = this.translate.instant('Failed to updated user, try again or contact administrator!');
        // this.userFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
       // console.log('COMPLETED');
      }

    );
    }
  onUserFormSubmit() {
    return new Promise<void>((resolve, reject) => {
      if (this.viewType === 'approve'){
        this.userAccessAllowed();
      }
      else {
      if (this.user_id) {
        this.updateUser();
      } else {
        this.addUser();
       //this.generateUserPass();
      }
    }
      resolve();
    });
  }

  renderSelect(item) {
    
  }

  refreshSelect(item) {

  }

  resetForm() {
    this.userForm = new FormGroup(projectforms.formUser);
    this.userForm.reset();
  }

  formChanged(data) {
   // console.log('user form changed ');
    this.userFormChange.emit(true);
  }
  btnAllowStatus(data){
    if (this.myFormGroup.get('grade').value._id !== undefined && this.myFormGroup.get('class').value._id != undefined ){
      this.userFormChange.emit(false);
    }
    return;
  }
  confirmEnableDisable(checkstatus){
    this.activeArchiveAdmin.emit(checkstatus);
    this.activeArchiveUser.emit(checkstatus);
  }

  changeButtonInViewAdminDialog() { //This method is setting the var adminActiveArchiveTab so that status change for admin is called.
    this.adminActiveArchiveTab = true;
    this.changeButtonInViewAdmin.emit(true);
  }

  removePhoto() {
    if (this.data.logo && this.data.logo.url) {
      delete this.data?.logo;      
    }
    
    if(this.myFormGroup.get('logo').value?.url){
      this.myFormGroup.get('logo').patchValue({url: null});
    }
  }

  tabHeadingInitial(data){
    let temp1;
    let temp2;
    if (data)
    {
      const temp = data.split(' ');
      temp1 = temp[0].charAt(0).toUpperCase();
      if (temp.length > 1) {
        temp2 = temp[1].charAt(0).toLowerCase();
      } else {
        temp2 = temp[0].charAt(1).toUpperCase();
      }
    }
    return temp1 + temp2;
  }
}
